import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AcessoService } from 'src/app/service/acesso/acesso.service';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';

@Injectable({
  providedIn: 'root',
})
export class SiopeService {
  localStorage: LocalStorage = new LocalStorage();
  headers = new HttpHeaders();
  url_acesso: string;
  cabecalho: any;
  filial: string;

  constructor(private http: HttpClient, private acesso: AcessoService) {
    this.url_acesso = this.acesso.validarUrl();

    if (localStorage.getItem('util') != null) {
      this.localStorage = JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
      this.cabecalho = this.headers.append('sessao', this.localStorage.Sessao);
      this.filial = this.localStorage.FilialAtual.toString();
    }
  }

  // Métodos GET (buscar dados)
  buscarColaboradorMatricula(matricula: string) {
    return this.http.get(`${this.url_acesso}cadastro-todos-matricula/${matricula}/${this.filial}`, {
      headers: this.cabecalho,
    });
  }

  buscarSeguimentos() {
    return this.http.get(`${this.url_acesso}siope/seguimentos`, {
      headers: this.cabecalho,
    });
  }

  buscarVinculos() {
    return this.http.get(`${this.url_acesso}siope/vinculos`, {
      headers: this.cabecalho,
    });
  }

  buscarTiposCategoria() {
    return this.http.get(`${this.url_acesso}siope/tipos-categoria`, {
      headers: this.cabecalho,
    });
  }

  buscarTiposQualificacao() {
    return this.http.get(`${this.url_acesso}siope/tipos-qualificacao`, {
      headers: this.cabecalho,
    });
  }

  buscarCategoria(IdTipoCategoria: number) {
    return this.http.get(`${this.url_acesso}siope/categorias/${IdTipoCategoria}`, {
      headers: this.cabecalho,
    });
  }

  buscarQualificacoes() {
    return this.http.get(`${this.url_acesso}siope/qualificacoes`, {
      headers: this.cabecalho,
    });
  }

  buscarLocalizacao() {
    return this.http.get(`${this.url_acesso}siope/localizacao`, {
      headers: this.cabecalho,
    });
  }

  buscarColaboradorSiope(numeroOrdem: string) {
    return this.http.get(`${this.url_acesso}siope/colaborador/${numeroOrdem}`, {
      headers: this.cabecalho,
    });
  }

  buscarQualificacaoSiope(numeroOrdem: string) {
    return this.http.get(`${this.url_acesso}siope/colaborador-qualificacao/${numeroOrdem}`, {
      headers: this.cabecalho,
    });
  }

  cadastrarDadosColaborador(dados: any) {
    return this.http.post(`${this.url_acesso}siope/colaborador`, dados, {
      headers: this.cabecalho,
    });
  }

  cadastrarQualificacao(dados: any) {
    return this.http.post(`${this.url_acesso}siope/colaborador-qualificacao`, dados, {
      headers: this.cabecalho,
    });
  }

  atualizarDadosColaborador(numeroOrdem: string, dados: any) {
    return this.http.put(`${this.url_acesso}siope/colaborador/${numeroOrdem}`, dados, {
      headers: this.cabecalho,
    });
  }

  atualizarQualificacao(numeroOrdem: string, dados: any) {
    return this.http.put(
      `${this.url_acesso}siope/colaborador-qualificacao/${numeroOrdem}`,
      dados,
      { headers: this.cabecalho }
    );
  }
}
